import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import BlogDetails from './pages/BlogDetails';
import Blogs from './pages/Blogs';
import Contactus from './pages/Contactus';
import AboutUs from './pages/AboutUs';
import Career from './pages/Career';
import CollaborativeMode from './pages/CollaborativeMode';
import CookiesPolicy from './pages/CookiesPolicy';
import InteractiveFlashcards from './pages/InteractiveFlashcards';
import InteractiveNotes from './pages/InteractiveNotes';
import InteractiveQuizzes from './pages/InteractiveQuizzes';
import InteractiveTeacher from './pages/InteractiveTeacher';
import Main from './pages/Main';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsCondition from './pages/TermsCondition';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/features/interactive-notes" element={<InteractiveNotes />} />
          <Route path="/features/interactive-quizzes" element={<InteractiveQuizzes />} />
          <Route path="/features/interactive-flashcards" element={<InteractiveFlashcards />} />
          <Route path="/features/interactive-teacher" element={<InteractiveTeacher />} />
          <Route path="/features/collaborative-mode" element={<CollaborativeMode />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookies-policy" element={<CookiesPolicy />} />
          <Route path="/terms-condition" element={<TermsCondition />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/career" element={<Career />} />
          <Route path="/blogs/:link" element={<BlogDetails />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
